import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';

interface SiteContextType {
    locales: string[];
}

const SiteContext = React.createContext<SiteContextType>({
    locales: [],
});

export function useSiteContext(): SiteContextType {
    return useContext(SiteContext);
}

export function useLocales(): string[] {
    const { locales } = useSiteContext() || {};
    return locales || [];
}

interface SiteProviderProps {
    children: React.ReactElement;
    locales: string[];
}

export const SiteProvider = ({ children, locales = [] }: SiteProviderProps) => {
    const value = useMemo(() => ({ locales }), [locales]);
    return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
};

export default SiteContext;
